var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10V8C8 5.239 9.239 3 12 3C14.761 3 16 5.239 16 8V10M12 15.75V15.25M16 15.75V15.25M8 15.75V15.25M3.5 17.8V13.2C3.5 12.08 3.5 11.52 3.718 11.093C3.90957 10.7163 4.21554 10.41 4.592 10.218C5.02 10.001 5.58 10.001 6.7 10.001H17.3C18.42 10.001 18.98 10.001 19.408 10.218C19.7843 10.4097 20.0903 10.7157 20.282 11.092C20.5 11.52 20.5 12.08 20.5 13.2V17.8C20.5 18.92 20.5 19.48 20.282 19.908C20.0903 20.2843 19.7843 20.5903 19.408 20.782C18.98 21 18.42 21 17.3 21H6.7C5.58 21 5.02 21 4.592 20.782C4.21569 20.5903 3.90974 20.2843 3.718 19.908C3.5 19.481 3.5 18.921 3.5 17.8Z",
    stroke: "#4D5559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgLock as ReactComponent };